import ReactGA from "react-ga4";

let initialized = false;

export const initializeAnalytics = () => {
  const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
  if (initialized || !measurementId) return;
  ReactGA.initialize(measurementId, { gtagOptions: { send_page_view: false } });
  initialized = true;
};

export const trackPageView = (path) => {
  if (initialized) ReactGA.send({ hitType: "pageview", page: path });
};

export const trackEvent = (category, action, label) => {
  if (initialized) ReactGA.event({ category, action, label });
};
